import { useCallback } from 'react'

import { useEventTracking } from '@web-app/context/EventTrackingContext'
import { ANALYTICS_EVENTS } from '@web-app/lib/analyticsEvents'

export type DownloadAppTap = keyof typeof ANALYTICS_EVENTS.downloadApp

export function useDownloadAppAnalytics() {
  const { trackEvent } = useEventTracking()

  const trackTap = useCallback(
    (tap: DownloadAppTap) => {
      trackEvent(ANALYTICS_EVENTS.downloadApp[tap])
    },
    [trackEvent],
  )

  return { trackTap }
}
